var _excluded = ["entity", "customClasses", "type"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { useTranslation } from 'react-i18next';
import c from 'classnames';
import TextField from '@uncinc/uncinc-react-kitchen-sink/dist/components/Form/TextField';
var WebformTextField = function WebformTextField(props) {
  var entity = props.entity,
    customClasses = props.customClasses,
    type = props.type,
    fieldProps = _objectWithoutProperties(props, _excluded);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var title = entity.get('#title');
  var required = entity.get('#required');
  var description = entity.get('#description');
  var placeholder = entity.get('#placeholder');
  var requiredError = entity.get('#required_error');
  var key = entity.get('#webform_key');
  var wrapperClassNames = c('WebformTextField', entity.getIn(['#wrapper_attributes', 'class', 0], ''));
  var labelClassNames = c(entity.getIn(['#label_attributes', 'class', 0], ''));
  var elementClassNames = c(entity.getIn(['#attributes', 'class', 0], ''), {
    error: fieldProps.errors[title] && fieldProps.touched[title] ? 'error' : ''
  });
  function validation(value) {
    var error;
    if (required && !value) {
      error = requiredError || t(['webform.components.text_field.required', 'webform.required', 'webform_required']);
    }
    return error;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: wrapperClassNames
  }, /*#__PURE__*/React.createElement(TextField, _extends({}, fieldProps, {
    className: elementClassNames,
    labelClassName: labelClassNames,
    title: title,
    type: type,
    required: required,
    description: description,
    placeholder: placeholder,
    fieldName: key,
    validation: validation,
    touched: props.touched[key],
    error: props.errors[key],
    value: props.values[key]
  })));
};
export default WebformTextField;